<template>
  <modal
    :is-hidden="isHidden"
    :is-open="isOpen"
    :title="$t('Messages.title')"
    ref="modal"
    v-on:clickclose="closeDialog"
    :alert="alertTitle"
    :alert-style="alertStyle"
    :alert-text="alertText"
    :alert-icon="alertIcon"
    alert-dismissable
    v-on:dismissalert="closeAlert"
    v-on:close="reset"
    no-footer
    no-padding
  >
    <messenger
      ref="messenger"
      :messages="messages"
      :active-request="activeRequest"
      :conversation-id="orderId"
      v-on:showloader="showLoader"
      v-on:hideloader="hideLoader"
      v-on:updateconversation="updateConversation"
      v-model="text"
      popup="true"
    ></messenger>
  </modal>
</template>
<script>
import Messenger from '../Elements/Messenger.vue';

var view = require('../view.js'),
    viewData = {
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      text: '',
      messages: []
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  components: {
    'Messenger': Messenger
  },
  props: {
    orderId: {},
    transactionnum: {
      type: String
    }
  },
  computed: {
    termsUrl() {
      return this.$root.termsUrl;
    },
    image() {
      if (this.$parent.files.length > 0)
        return this.$parent.previewImage(this.$parent.files[0]);
    }
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen') {
            viewData[i] = resetData[i];
          }
        }
      }
    },
    updateConversation(messages) {
      this.messages = messages;
    },
    closeDialog() {
      if (!this.activeRequest) {
        this.$refs.modal.close(this);
      }
    },
    openDialog() {
      this.$refs.modal.open(this);
      this.$refs.messenger.loadConversation();
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
    },
    showLoader() {
      this.activeRequest = true;
    },
    hideLoader() {
      this.activeRequest = false;
    }
  }
});
</script>
